import { render, staticRenderFns } from "./NormalSearchNav163.vue?vue&type=template&id=3daa2170&scoped=true&"
import script from "./NormalSearchNav163.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav163.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daa2170",
  null
  
)

export default component.exports